import React, { useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import YoutubeEmbed from '../components/YoutubeEmbed';

import capybara from '../img/capybara.gif';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from "react-bootstrap/Button";
import '../styles/Video.css'

const Video = (props) => {
    const { cogLoad } = props;
    const [link, setLink] = useState('');
    const [vurl, setVURL] = useState("wE6pEsjgdHo");
    const [title, setTitle] = useState("Capybara Mental Tracker |")

    const handleSelect = (e) => {
        console.log(e);
        console.log(cogLoad);
        setVURL(e);
    }

    const handleLink = async(e) => {
        e.preventDefault()

        const id = getId(link)

        if (id) {
            setVURL(id);
        }
    }

    const getId = (link) => {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = link.match(regExp);

        return (match && match[2].length === 11)
            ? match[2]
            : null;
    }

    return (
        <div className="VideoFrame">
            <div className="ChooseVideo">
                <Navbar bg="dark" variant="dark">
                    <Navbar.Brand href="#home">
                        <img
                        alt=""
                        src={capybara}
                        width="30"
                        height="30"
                        className="d-inline-block align-top"
                        />{' '}
                        {title}
                    </Navbar.Brand>
                    {/*<DropdownButton*/}
                    {/*    alignRight*/}
                    {/*    title="Select your next educational video"*/}
                    {/*    id="edu-video-dropdown"*/}
                    {/*    onSelect={handleSelect}*/}
                    {/*>*/}
                    {/*    <Dropdown.Item eventKey="Qt6A5wgwlLE">Super Earth</Dropdown.Item>*/}
                    {/*    <Dropdown.Item eventKey="qd9oEhlyIKY">Deadliest Substance on Earth</Dropdown.Item>*/}
                    {/*    <Dropdown.Item eventKey="aEOMrpAJf-0">When You Get Knocked Out</Dropdown.Item>*/}
                    {/*</DropdownButton>*/}
                    <form onSubmit={handleLink} className="link-search">
                        <input value={link} name='link' onChange={(e) => { setLink(e.target.value); }} placeholder='YouTube Link' required />
                        <Button bsStyle="primary" type='submit'>Find</Button>
                    </form>
                </Navbar>
            </div>
            <div className="video-container">
                <YoutubeEmbed embedId={vurl} cogLoad={cogLoad} />
            </div>
        </div>
    );
    
}

export default Video
